module.exports = __webpack_public_path__ + "media/images/pitches/screenshot-message-sp-f97e16e9dc2237826e98bf0a1265a9fe.png";